module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }